"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconReceipt = function SvgIconReceipt(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "receipt icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Receipt Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.999 42.774l2.833-2.834 2.833 2.834L15.5 39.94l2.833 2.834 2.833-2.834L24 42.774l2.833-2.834 2.833 2.834L32.5 39.94l2.833 2.834 2.833-2.834L41 42.774V4.996L38.165 7.83l-2.833-2.833L32.5 7.83l-2.834-2.833-2.833 2.833L24 4.996 21.165 7.83l-2.833-2.833L15.5 7.83l-2.834-2.833L9.832 7.83 7 4.996v37.778zm28.333-24.556H12.665v-3.777h22.667v3.777zm0 7.556H12.665v-3.778h22.667v3.778zm0 7.555H12.665v-3.777h22.667v3.777z"
  }));
};

var _default = SvgIconReceipt;
exports.default = _default;